import { useAuth0 } from '@auth0/auth0-react';

export default function SignupPrompt({ isOpen, onClose, message }) {
  const { loginWithRedirect } = useAuth0();

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
      },
      appState: { returnTo: window.location.pathname, wasSignup: true },
    });
  };

  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname },
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/65 flex items-center justify-center z-50 p-4">
      <div className="glass-strong max-w-md w-full p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 btn-ghost px-2 py-2 text-slate-400 hover:text-slate-600 dark:text-slate-300 dark:hover:text-slate-100"
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Icon */}
        <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-fuchsia-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-[0_16px_30px_-20px_rgba(168,85,247,0.70)] border border-slate-200 dark:border-white/10">
          <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>

        {/* Content */}
        <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50 text-center mb-2">
          Create an Account
        </h2>
        <p className="text-slate-600 dark:text-slate-300 text-center mb-6">
          {message || 'Sign up to download your icons and unlock more features.'}
        </p>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleSignup}
            className="w-full btn-primary py-3"
          >
            Sign Up Free
          </button>
          <button
            onClick={handleLogin}
            className="w-full btn-secondary py-3"
          >
            Already have an account? Log in
          </button>
        </div>

        {/* Benefits */}
        <div className="mt-6 pt-6 border-t border-slate-200 dark:border-white/10">
          <p className="text-xs text-slate-400 text-center mb-3">What you get with an account:</p>
          <ul className="space-y-2">
            <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
              <svg className="w-4 h-4 text-emerald-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              Download your icons in all sizes
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
              <svg className="w-4 h-4 text-emerald-500 dark:text-emerald-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              Unlimited icon generations
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
              <svg className="w-4 h-4 text-emerald-500 dark:text-emerald-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              Save and access your icon history
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
